import { Loader } from 'lucide-react'
import { H4 } from '@/components/sv/typographies'
import { Skeleton } from '@/components/ui/skeleton'

export const BuildSettingsFallback = ({
  showFramework = true,
}: {
  showFramework?: boolean
}) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <H4>Build settings</H4>
        {showFramework ? (
          <div className="flex items-center gap-2 text-sm text-muted-foreground leading-4.5">
            <Loader className="size-4 animate-spin" />
            Detecting framework...
          </div>
        ) : null}
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Skeleton className="h-4.5 w-8" />
          <Skeleton className="h-3.5 w-45" />
        </div>
      </div>
      <div className="grid grid-cols-2 items-start gap-4">
        <div className="flex flex-col gap-2">
          <Skeleton className="h-3.5 w-25" />
          <Skeleton className="w-full h-9" />
        </div>
        <div className="flex flex-col gap-2">
          <Skeleton className="h-3.5 w-25" />
          <Skeleton className="w-full h-9" />
        </div>
      </div>
      <div className="grid grid-cols-2 items-start gap-4">
        <div className="flex flex-col gap-2">
          <Skeleton className="h-3.5 w-25" />
          <Skeleton className="w-full h-9" />
        </div>
        <div className="flex flex-col gap-2">
          <Skeleton className="h-3.5 w-25" />
          <Skeleton className="w-full h-9" />
        </div>
      </div>
      <div className="grid grid-cols-2 items-start gap-4">
        <div className="flex flex-col gap-2">
          <Skeleton className="h-3.5 w-25" />
          <Skeleton className="w-full h-9" />
        </div>
        <div className="flex flex-col gap-2">
          <Skeleton className="h-3.5 w-25" />
          <Skeleton className="w-full h-9" />
        </div>
      </div>
    </div>
  )
}
